import React, {useContext, useEffect, useRef, useState} from 'react';
import { IonApp, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/layout.css';

//import { ShowItemPicsModal } from './Modal_ShowItemPics';
//import { Modal_AddIngredientToRecipe} from './Modal_AddIngredient_To_Recipe';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';




 export function ViewItemDetailDataModal (props) {



    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    let [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    let [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [employeeID, setEmployeeID] = useState(authenticatedMerchent_context.employeeID);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL] = useState(authenticatedMerchent_context.baseURL);
    
    let [items, setItems] = useState([]);
    let [selectedIdx, setSelectedIdx] = useState(0);

    let [itemID, setItemID] = useState(props.data.itemID);
    let [itemName, setItemName] = useState(props.data.itemName);

    let [itemQtyInStock, setItemQtyInStock] = useState(props.data.itemQtyInStock);
    let [itemPublicPrice, setItemPublicPrice] = useState(props.data.itemPublicPrice);
    let [itemPicsModal, setItemPicsModal] = useState(false);
    let [viewItemDetailsData, setViewItemDetailsData] = useState([]);
    let [showItemDetails, setShowItemDetails] = useState(false);

    let [itemPic1, setItemPic1] = useState(null);
    let [itemPic2, setItemPic2] = useState(null);
    let [itemPic3, setItemPic3] = useState(null);
    let [itemPic4, setItemPic4] = useState(null);

    let [selectedFile, setSelectedFile] = useState(null);

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);


    let [openAddIngredientModal, setOpenAddIngredientModal] = useState(false);
    // let createItemAddition_type = useRef(props.data.addition_type);
    // let createItemTypeRef = useRef(props.data.itemType);
    // let createItemDescriptionRef = useRef(props.data.itemDescription);
    // let createItemPartNumRef = useRef(props.data.vendorPartNum);
    // let createItemPhoneNumberRef = useRef(props.data.vendorPartNum);
    // let createItemAddressRef = useRef(props.data.vendorAddress);
    // let createItemCityRef = useRef(props.data.vendorCity);
    // let createItemCountryRef = useRef(props.data.vendorCountry);
    // let createItemCostPerUnitRef = useRef(props.data.costPerUnit);
    // let createItemQtyInStockRef = useRef(props.data.salePrice);
    // let createItemQtyInUse = useRef(props.data.qtyInUse);
    // let createItemDateCreated = useRef(props.data.dateCreated);
    // let createItemAddedBy = useRef(props.data.addedBy);


    let [createItemAddition_type, setCreateItemAddition_type] = useState(props.data.addition_type);

    let [itemType, setItemType] = useState(null);
    let [itemDescription, setItemDescription] = useState(null);
    let [itemPartNum, setItemPartNum] = useState(null);
    let [itemPhoneNumber, setItemPhoneNumber] = useState(null);
    let [itemAddress, setItemAddress] = useState(null);
    let [itemCity, setItemCity] = useState(null);
    let [itemCountry, setItemCountry] = useState(null);
    let [itemCostPerUnit, setItemCostPerUnit] = useState(null);
    //let [itemQtyInStock, setItemQtyInStock] = useState(null);
    let [itemQtyInUse, setItemQtyInUse] = useState(null);
    let [itemDateCreated, setItemDateCreated] = useState(null);
    let [itemAddedBy, setItemAddedBy] = useState(null);
    let [attachment, setAttachment] = useState(null);
    let [quantityAvailable, setQuantityAvailable] = useState(null);
    let [quantityUnits, setQuantityUnits] = useState(null);

    const parseArray = (raw) => {
        try {
          let v = raw;
          if (typeof v === "string") v = JSON.parse(v);
          while (typeof v === "string" && (/^\s*[\[{]/.test(v))) v = JSON.parse(v);
          return Array.isArray(v) ? v : [];
        } catch {
          console.warn("Bad itemID_list JSON:", raw);
          return [];
        }
      };

    const populateFormFromItem = (p) => {
        setItemID(p.itemID ?? "");
        setItemType(p.itemType ?? "");
        setItemName(p.itemName ?? "");
        setItemDescription(p.itemDescription ?? ""); // adjust if your payload has it
        setItemPartNum(p.itemPartNum ?? "");
        setItemPhoneNumber(p.itemPhoneNumber ?? "");
        setItemAddress(p.itemAddress ?? "");         // adjust indices below to include these
        setItemCity(p.itemCity ?? "");
        setItemCostPerUnit(p.itemCostPerUnit ?? "");
        setItemQtyInStock(p.itemQtyInStock ?? "");
        setItemPic1(p.itemPic1 ?? "");
        setItemPic2(p.itemPic2 ?? "");
        setItemPic3(p.itemPic3 ?? "");
        setItemPic4(p.itemPic4 ?? "");
        setItemDateCreated(p.itemDateCreated ?? "");
        setItemAddedBy(p.itemAddedBy ?? "");
      };
      
      // When items load or selection changes, populate the form

function getItemDetailData() {

    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Accept': 'text/html, application/json',
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            Tracker: '74301_itemList_restaurant_details',
            user: acctID,
            xInventoryItemID: props.data.itemID,
            sessionID: sessionID,
        }),
    };

    fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {


                const rows = res.toString().split("~~~");
                const parsed = rows.slice(0, -1).map((row) => {
                    const cols = row.split("|");

                    // Adjust these indices to your exact backend order
                    const itemID_list = parseArray(cols[1]); // JSON array-of-objects in col 1
                    return {
                        itemID: cols[0],
                        //itemID_list,
                        //itemType: cols[2],
                        itemName: cols[1],
                        itemDescription: cols[2], //added
                        itemPartNum: cols[3],
                        itemVendorName: cols[4], //added
                        itemPhoneNumber: cols[5],
                        itemAddress: cols[6], //added
                        itemCity: cols[7],      //added
                        itemCountry: cols[8],   //added
                        itemCostPerUnit: Number(cols[9]) || 0,
                        itemQtyInStock: Number(cols[10]) || 0,
                        // itemPic1: cols[8] || "",
                        // itemPic2: cols[9] || "",
                        // itemPic3: cols[10] || "",
                        // itemPic4: cols[11] || "",
                        //itemQtyInUse: cols[11] || "",
                        itemDateCreated: cols[12] || "",
                        attachment: cols[13] || "",
                        itemType: cols[14] || "",
                        itemAddedBy: cols[15] || "",
                        // itemDescription: cols[?] || "",   // include if provided
                    };
                });
                setItems(parsed);
                setSelectedIdx(0); // show the first one
        });
}

function updateItem() {

    let formData = new FormData();
    //formData.append('xItemPics', totalItemPics);
    //formData.append('xItemPics', [ItemPic1, ItemPic2, ItemPic3, ItemPic3]);
    formData.append('Tracker', '74300_update_item_inventory');
    formData.append('user', acctID);
    formData.append('merchantSchema', schema);
    formData.append('xInventoryItemID', itemID);
    formData.append('xInventoryItemType', itemType);
    formData.append('xInventoryItemName', itemName);
    formData.append('xInventoryItemDescription', itemDescription);
    formData.append('xInventoryVendorPartNum', itemPartNum);
    formData.append('xInventoryVendorPhoneNumber', itemPhoneNumber);
    //formData.append('xItemAddressNumber', itemAddress);
    //formData.append('xItemCity', itemCity);
    //formData.append('xItemCountry', itemCountry);
    formData.append('xInventoryItemCostPerUnit', itemCostPerUnit);
    formData.append('xInventoryItemQtyInStock', itemQtyInStock);
    //formData.append('xPic1', itemPic1);
    //formData.append('xPic2', itemPic2);
    //formData.append('xItemPic3', itemPic3);
    //formData.append('xItemPic4', itemPic4);
    //formData.append('xAttachment', attachment);
    //formData.append('xItemDateCreated', itemDateCreated);
    //formData.append('xCreatedByEmployee', itemAddedBy);
    //formData.append('xStoreFront', itemPublicPrice);
    //formData.append('xItemQuantityAvailable', itemQtyInUse);
    formData.append('sessionID', sessionID);



    const requestOptions = {
        enctype: 'multipart/form-data',
        method:'POST',
        //credentials: 'include',
        file: formData,
        body: formData,
        contentType: false,
        processData: false,
    }
    


    fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
    .then(res => res.text())
    .then(data => {

        alert(data);

        getItemDetailData(); 

    })
    .catch(error => {
        console.error(error);
    })

}


function closeModalHandler() {

    props.closeModal(false);
}

useEffect(() => {
    if (items.length) populateFormFromItem(items[selectedIdx] || items[0]);
  }, [items, selectedIdx]);

useEffect(() =>  {

    //alert("In produt detals modal");
    //alert(props.data.ItemID);

        
    getItemDetailData(); 

}, [])

            return(

                <React.Fragment>
                {props.openModal == true ?
                (
            <IonModal id='showItemDetails' isOpen={ props.openModal}>

                <IonHeader style={{color: "black"}}>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonText>Item DETAILS</IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='6'>Item ID</IonCol>
                                <IonCol size='6'>Item Name</IonCol>
                            </IonRow>
                            <IonRow >
                                <IonCol size='6'><IonText>{itemID}</IonText></IonCol>
                                <IonCol size='6'><IonText>{itemName}</IonText></IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonHeader>
                    <IonContent className='grid_content'>
                        <IonGrid >
                            <IonRow>
                                <IonCol size='2'><h4>ID</h4></IonCol>
                                <IonCol size='4'><h4>NAME</h4></IonCol>
                                <IonCol size='3'><h4>COST</h4></IonCol>
                                <IonCol size='3'><h4>UNIT</h4></IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Type: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemType}
                                    placeholder="Enter Item Type"
                                    onIonChange={(e) => setItemType(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Name: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemName}
                                    placeholder="Enter Item Name"
                                    onIonChange={(e) => setItemName(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Description: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemDescription}
                                    placeholder="Enter Item Description"
                                    onIonChange={(e) => setItemDescription(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Part Number: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemPartNum}
                                    placeholder="Enter Item Part Number"
                                    onIonChange={(e) => setItemPartNum(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Phone Number: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemPhoneNumber}
                                    placeholder="Enter Item Phone Number"
                                    onIonChange={(e) => setItemPhoneNumber(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            {/*<IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Address: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemAddress}
                                    placeholder="Enter Item Address"
                                    onIonChange={(e) => setItemAddress(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item City: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemCity}
                                    placeholder="Enter Item City"
                                    onIonChange={(e) => setItemCity(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Country: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <select name="country" id='country' value={itemCountry} onChange={(e) => setItemCountry(e.target.value)}>
                                        <option value='GHANA' selected>Ghana</option>
                                        <option value='USA'>USA</option>
                                        <option value='CHINA'>CHINA</option>
                                    </select>
                                </IonCol>
                                </IonRow>  */}
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Item Cost Per Unit: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemCostPerUnit}
                                    placeholder="Enter Item Cost Per Unit"
                                    onIonChange={(e) => setItemCostPerUnit(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Quantity In Stock: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemQtyInStock}
                                    placeholder="Enter Item Sale Price"
                                    onIonChange={(e) => setItemQtyInStock(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            {/*<IonRow class='gridResultBody'>
                                <IonCol size='6' class='gridResultHeaders'>Item Images</IonCol>
                                <IonCol size='6' class='gridResultColumns'>
                                    <ShowItemPicsModal openModal={ itemPicsModal } closeModal={() => setItemPicsModal(false)} data={{
                                    itemPic1: itemPic1, 
                                    itemPic2: itemPic2, 
                                    itemPic3: itemPic3, 
                                    itemPic4: itemPic4, 
                                    itemID: itemID, 
                                    itemQtyInStock: itemQtyInStock
                                    }}></ShowItemPicsModal>
                                    <IonButton class='gridResultColumnButton' onClick={() => setItemPicsModal(true)}> View </IonButton>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Date Created: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemDateCreated}
                                    placeholder="Date Created"
                                    onIonChange={(e) => setItemDateCreated(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Created By Employee: </IonLabel>
                                    <IonInput className='professional-input'
                                    value={itemAddedBy}
                                    placeholder="Created By"
                                    onIonChange={(e) => setItemAddedBy(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Quantity Available: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonText>{quantityAvailable}</IonText>
                                </IonCol>
                               <IonCol size='12'>
                                    <IonInput className='professional-input'
                                    value={quantityAvailable}
                                    placeholder="Enter Quantity Available"
                                    onIonChange={(e) => setQuantityAvailable(e.target.value)}
                                    ></IonInput>
                                </IonCol>
                            </IonRow>  
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked"> Qty Units: </IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <select name="qtyUnitsRef" id='qtyUnitsRef' value={quantityUnits} onChange={(e) => setQuantityUnits(e.target.value)}>
                                        <option value='ea' selected>Quantity</option>
                                        <option value='g'>grams</option>
                                        <option value='kg'>Kilograms</option>
                                        <option value='L'>Liters</option>
                                    </select>
                                </IonCol>
                            </IonRow>  */}
                            </IonGrid>
                        
                        </IonContent>
                        <IonFooter class='grid_footer'>
                                <IonGrid>
                                {authenticatedMerchent_context.accessRights[0] == 'admin' && 
                                    <IonRow>
                                        <IonCol size="6">
                                            <IonButton onClick={() => updateItem()}> Save </IonButton>
                                        </IonCol>
                                        <IonCol size="6">
                                            <IonButton  onClick={() => closeModalHandler()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>}
                                {authenticatedMerchent_context.accessRights[0] != 'admin' && 
                                    <IonRow>
                                        <IonCol size="12">
                                            <IonButton  onClick={() => closeModalHandler()}>Cancel </IonButton>
                                        </IonCol>
                                    </IonRow>}
                                </IonGrid>
                        </IonFooter>
                    </IonModal>) : null}
    </React.Fragment>
            )
}   



export default ViewItemDetailDataModal;